<mat-list role="list" *ngIf="files?.length>0">
    <mat-list-item role="listitem" *ngFor="let item of files">
        <mat-icon mat-list-icon>folder</mat-icon>
        <a mat-line [href]="item?.downloadURl" target="blank">{{item.name}}</a>
        <div mat-line> {{item.fileSize | fileSize}} </div>
        <button matTooltip="Delete" mat-button mat-icon-button (click)="onRemove.emit(item)">
            <mat-icon>delete</mat-icon>
        </button>
    </mat-list-item>
</mat-list>